import TimeAgo from 'javascript-time-ago'
import ja from 'javascript-time-ago/locale/ja.json'
import type { Ref } from 'vue'
import { computed } from 'vue'

TimeAgo.addDefaultLocale(ja)
const timeAgo = new TimeAgo('ja-JP')

export const useTimeAgo = (date: Ref<Maybe<Date>>) => {
  return computed(() => {
    if (!date.value) {
      return null
    }
    return timeAgo.format(date.value, 'twitter')
  })
}
